// Polyline.js
import { useContext, useEffect, useRef } from 'react';
import { GoogleMapsContext, useMapsLibrary } from '@vis.gl/react-google-maps';

export const Polyline = (props) => {
  const { map } = useContext(GoogleMapsContext) ?? {};
  const mapsLib = useMapsLibrary('maps'); // waits until Google Maps is loaded
  const polylineRef = useRef(null);

  // Create polyline once mapsLib is ready
  useEffect(() => {
    if (!mapsLib || polylineRef.current) return;
    polylineRef.current = new mapsLib.Polyline();
  }, [mapsLib]);

  // Attach / detach from map
  useEffect(() => {
    if (!map || !polylineRef.current) return;
    polylineRef.current.setMap(map);
    return () => {
      if (polylineRef.current) {
        polylineRef.current.setMap(null);
      }
    };
  }, [map, polylineRef.current]);

  // Update options whenever props change
  useEffect(() => {
    if (!polylineRef.current) return;
    polylineRef.current.setOptions(props);
  }, [props]);

  return null;
};
